/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  var sticky = document.querySelector('[data-torrela-sticky-atc]');
  var stickyButton = document.querySelector('[data-torrela-sticky-atc-button]');
  var mainButton = document.querySelector('.ProductForm__AddToCart');

  if (!sticky || !stickyButton || !mainButton || !window.matchMedia('(max-width: 640px)').matches) {
    return;
  }

  var updateVisibility = function (visible) {
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  var onScroll = function () {
    var rect = mainButton.getBoundingClientRect();
    updateVisibility(rect.bottom < 0);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  stickyButton.addEventListener('click', function () {
    if (!mainButton.disabled) {
      mainButton.click();
    }
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant) {
      return;
    }

    var available = !!variant.available;
    stickyButton.disabled = !available;
    stickyButton.textContent = available ? stickyButton.getAttribute('data-add-label') : stickyButton.getAttribute('data-sold-label');
  });

  document.addEventListener('product:added', function () {
    updateVisibility(false);
  });
});